import React, { useState, useContext, createContext, useEffect } from 'react';
import useAxios from 'axios-hooks';
import LoadPanel from 'app/components/LoadPanel';
import { NotFoundPage } from 'app/components/NotFoundPage';
import { WrapContent } from 'app/components/WrapContent';

const List = React.lazy(() => import('./List'));

const defaultParams = {};

// create context
const RegisterDictionaryContext = createContext({});

RegisterDictionaryContext.displayName = 'RegisterDictionaryContext';

export const useRegisterDictionary = () => {
  const context = useContext(RegisterDictionaryContext);
  return context;
};

const RegisterMultilingualDictionary = () => {
  const [params, setParams] = useState(defaultParams);
  const [data, setData] = useState([]);
  const [type, setType] = useState('ui');
  const [modeView, setModeView] = useState({
    type: 'list',
  });

  const [{ data: resData, loading: loadingfetchData }, refetchData] = useAxios(
    {
      url: '/multi-language',
      method: 'POST',
    },
    { manual: true, autoCancel: true, useCache: false },
  );

  const value: any = {
    modeView,
    setModeView,
    params,
    setParams,
    refetchData,
    data,
    setData,
    type,
    setType,
  };

  const renderContent = () => {
    switch (modeView?.type) {
      case 'list':
        return <List />;
      default:
        return <NotFoundPage />;
    }
  };

  useEffect(() => {
    if (resData?.data) {
      setData(resData?.data?.sort((a, b) => a?.base - b?.base));
    }
  }, [resData]);

  useEffect(() => {
    if (data?.length) {
      setData([]);
    }
  }, [type]);
  const loadingAll = loadingfetchData;

  return (
    <WrapContent>
      <RegisterDictionaryContext.Provider value={value}>
        <React.Suspense fallback={<LoadPanel visible={true} />}>
          <LoadPanel visible={loadingAll} />
          {renderContent()}
        </React.Suspense>
      </RegisterDictionaryContext.Provider>
    </WrapContent>
  );
};

export default RegisterMultilingualDictionary;
